<script>
    import data2 from "./../data/sheet.csv"
    import content from "./../data/doc.json"
    import Icon from "../components/helpers/Icon.svelte"
    import {Container,Row,Col,TabContent, TabPane,Spinner} from 'sveltestrap'
    import {fade} from 'svelte/transition'
    import viewport from "../stores/viewport.js"
    import { fetchGoogle } from "../actions/refreshData.js";
    import {onMount} from 'svelte'
    import inView from '../actions/inView.js'
   let open = false;
   let loading = true;   

   function toggle(direction) {
       if (direction == 'in') {
            setTimeout(function() {
                open = true;
            }, 2000);
       } else {
           open = false;
       }
   }

   export let filter1 = 'all';
   export let filter2 = 'all';
   export let sort = 'abc';
   export let mode = 'full';
   let search;
   let filteredData = data2;
   let sortedData = filteredData;
   let data;


   function filterGrid () {
       loading = true;
       fetchGoogle().then(function(result) {
            data = result;
            if (search) {
                filteredData = data.filter(function (i,n) {
                    for (var key in filter1) {
                        let full_name = i.candidate_fn.toLowerCase()+' '+i.candidate_ln.toLowerCase();
                        if (i.candidate_fn.toLowerCase().includes(search.toLowerCase()) || full_name.includes(search.toLowerCase()) || i.candidate_ln.toLowerCase().includes(search.toLowerCase()) || i.riding.toLowerCase().includes(search.toLowerCase()))
                        return true;
                    }
                    return false;
                })
            } else if (filter1 == 'all') {
                filteredData = data;
            } else {
                filteredData = data.filter(function (i,n) {
                    return i.party_ml.indexOf(filter1) > -1;
                });
            }

            if (filter2 == 'yes') {
                filteredData = filteredData.filter(function(i,n) {
                    if (i.date_of_pledge) {
                        return true;
                    } else {
                        return false;
                    }
                })
            } else if (filter2 == 'no') {
                filteredData = filteredData.filter(function(i,n) {
                    if (i.date_of_pledge) {
                        return false;
                    } else {
                        return true;
                    }
                })
            }

            sortedData = filteredData.sort(function(a,b) {
                        return b.elected.localeCompare(a.elected) || b.date_of_pledge.localeCompare(a.date_of_pledge) || a.candidate_ln.localeCompare(b.candidate_ln);
                    })
        });
       loading = false;
   }
   filterGrid();
   
   
   
</script>

{#if loading}

   <div id="spinner">
       <Spinner color=primary/>
   </div>

{:else}

<Container>
       <Row>
           <Col sm=12 lg={{size:4,offset:0}}>
               <div class="control">
                       <label for="cat">Filter by party:</label>

                       <!-- svelte-ignore a11y-no-onchange -->
                       <select bind:value={filter1} on:change="{() => filterGrid()}" name="party" id="party">
                            <option value="all">All</option>
                           <option value="lib">Liberal party</option>
                           <option value="con">Conservative party</option>
                           <option value="ndp">NDP</option>
                           <option value="green">Green party</option>
                           <option value="bq">Bloc Québécois</option>
                           <option value="other">Other</option>
                       </select>
               </div> 
           </Col>
           <Col sm=12 lg={{size:4}}>
            <div class="control">
                    <label for="cat">Has taken the TMX pledge?</label>

                    <!-- svelte-ignore a11y-no-onchange -->
                    <select bind:value={filter2} on:change="{() => filterGrid()}" name="pledge" id="pledge">
                         <option value="all">All</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
            </div> 
        </Col>
           <Col sm=12 lg={{size:4}}>
               <div class="control">
                       <label for="search">Search for a candidate or riding:</label>

                       <!-- svelte-ignore a11y-no-onchange -->
                       <input type="text" bind:value={search} on:keyup="{() => filterGrid()}" name="search" id="order">
               </div> 
           </Col>
       </Row>
       <Row>
           <Col sm=12>
               <div class="candidates-grid" use:inView on:enter={() => toggle('in')} on:exit={() => toggle('out')}>
               {#each sortedData as candidate}
                   <div class="candidate-box {candidate.elected}">
                    <div class="candidate-content">

                        <h4>{candidate.candidate_fn+" "}{candidate.candidate_ln} </h4>
                        {#if candidate.party.indexOf('Liberal') > -1}
                            <img src="assets/libs.png" alt="Liberal party of Canada">
                        {:else if candidate.party.indexOf('Conservative') > -1}
                            <img src="assets/cons.png" alt="Conservative party of Canada">
                        {:else if candidate.party.indexOf('Democratic') > -1}
                            <img src="assets/ndplogo.png" alt="New Democratic Party">
                        {:else if candidate.party.indexOf('Green') > -1}
                            <img src="assets/greens.png" alt="Green party of Canada">
                        {:else if candidate.party.indexOf('Bloc') > -1}
                            <img src="assets/bq.png" alt="Bloc québécois">
                        {:else}
                            <p>{candidate.party}</p>
                        {/if}
                        <p><i>{candidate.riding}</i></p>
                    </div>
                        {#if candidate.date_of_pledge}
                            <div class="pledge pledge-yes">
                                PLEDGED TO <br />STOP TMX
                            </div>
                        {:else}
                            <div class="pledge pledge-no">
                                HAS NOT PLEDGED <br />TO STOP TMX
                            </div>
                        {/if}
                   </div>
               {/each}
               </div>
           </Col>  
       </Row>
   </Container>

   <!--{#if open}
        <div class="ett-cta">
            <div on:click={() => toggle('out')} class="close"><Icon name="x" stroke="var(--white)" stroke-width="2em" width="2em" height="2em" /></div>
            {@html content.voter_pledge}
            <a href="https://www.stand.earth/election-candidate-pledge-tmx" target="_new">Email your candidates >></a>
        </div>
    {/if}-->
{/if}


<style>
   .candidates-grid {
       display:flex;
       flex-flow: row wrap;
       justify-content: center;
       text-align:center;
   }

   .candidate-box {
       width:290px;
       min-height:133px;
       max-height:300px;
       position:relative;
       text-align:center;
       border:1px solid #cccccc;
       margin-right:20px;
       margin-bottom:20px;
       padding-bottom:70px;
   }

   .elected {
       border:5px solid var(--stand-secondary);
   }

   .elected::before {
       content: "ELECTED";
       padding:8px;
       font-weight:bold;
       margin-top:-5px;
       color:#fff;
       background:var(--stand-secondary);
   }

   .candidate-content {
        padding:20px;
        min-height:150px;
   }

   .candidate-box h4 {
       font-family: 'Gotham';
       color:var(--stand-tertiary);
   }

   .candidate-box p {
       margin-bottom:0px;
   }
   

   .candidate-box img {
       max-width:100px;
       max-height:100px;
       padding-top:10px;
       padding-bottom:10px;
       margin:auto;

   }

   .control select, .control input {
       width:100%;
       margin-bottom:30px;
   }

   #spinner {
   width:100%;
   height:200px;
   margin-top:10%;
   text-align:center;
 }

 .pledge {
    padding:10px;
    font-family:'Gotham';
    text-transform:uppercase;
    color:var(--white);
    display:block;
    width:100%;
    position:absolute;
    bottom:0px;
 }

 .pledge-yes {
     
     background-color:green;
     border:1px solid green;

 }
 .pledge-no {
     background-color:grey;
     border:1px solid grey;
 }

 .ett-cta {
     background: rgba(181,18,27,1);
     color:var(--white);
     padding:20px;
     padding-top:30px;
     position:fixed;
     bottom:0px;
     right:0px;
 }

 .ett-cta a {
     float:right;
     background:var(--white);
     color:var(--stand-secondary);
     padding:10px;
     text-decoration:none;
     font-family:'Gotham';
     text-align:center;
 }

 .close {
     float:right;
     margin-top:-20px;
     cursor:pointer;
 }
</style>
